import { Component, OnInit } from '@angular/core';
import { GetProfile } from '@app/finxone-web-frontend/app/lib/actions/user-profile.action';
import { UserDetail } from '@app/finxone-web-frontend/app/lib/dtos/user-detail.dto';
import { ConfigService } from '@app/finxone-web-frontend/app/lib/services/config-service/config-service.service';
import { RoleState, RoleStateModel } from '@app/finxone-web-frontend/app/lib/state/role.state';
import { ProfileState } from '@app/finxone-web-frontend/app/lib/state/user-profile.state';
import { AutoDestroy } from '@finxone-platform/shared/base-types';
import {
  BaseCssProperties,
  ProfileStateModel,
  ProviderClass,
  UiZoneWidgetAttributeConfig,
  baseCssConfigStyle,
} from '@finxone-platform/shared/sys-config-types';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject, map, take } from 'rxjs';
import { BaseComponent } from '../../base/base.component';
@Component({
  standalone: false,
  selector: 'finxone-web-frontend-profile-picture-widget',
  templateUrl: './profile-picture-widget.component.html',
})
export class ProfilePictureWidgetComponent extends BaseComponent implements OnInit {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  userDetail: UserDetail = {} as UserDetail;
  @Select(RoleState.getRole)
  roles!: Observable<RoleStateModel>;
  roleInfo: RoleStateModel;

  @Select(ProfileState.getProfile)
  profileStateData!: Observable<ProfileStateModel>;
  public textContentTemplate = '';
  public alignStyle: baseCssConfigStyle;
  public backgroundShape: string;

  constructor(
    private store: Store,
    private configService: ConfigService,
    public dataIn: ProviderClass<UiZoneWidgetAttributeConfig>,
  ) {
    super();
  }

  ngOnInit(): void {
    this.roles.subscribe((roles) => {
      this.roleInfo = roles;
    });
    this.onGetProfileDetails();

    if (this.dataIn != undefined) {
      this.attri = this.dataIn.attri ?? null;
      this.backgroundShape = this.dataIn?.attri?.widgetProperties?.['backgroundShape'];
      this.onLoadWidgetConfiguration();
      this.handleBackgroundShape(this.backgroundShape);
    }
  }
  private onLoadWidgetConfiguration(): void {
    this.contentStyle = this.configService.getSpecificBaseCssStyle(this.attri, [
      BaseCssProperties.MARGIN,
      BaseCssProperties.PADDING,
      BaseCssProperties.DIMENSIONS,
      BaseCssProperties.BACKGROUND_COLOR,
      BaseCssProperties.BORDER,
      BaseCssProperties.BOX_SHADOW,
    ]);
    this.alignStyle = this.configService.getSpecificBaseCssStyle(this.attri, [BaseCssProperties.TEXTALIGN]);
  }

  private onGetProfileDetails(): void {
    this.store.dispatch(new GetProfile());
    this.profileStateData
      .pipe(
        take(2),
        map((profileDetail) => {
          this.userDetail = profileDetail;
        }),
      )
      .subscribe();
  }

  public handleBackgroundShape(shape: string) {
    switch (shape) {
      case 'square':
      case 'rectangle':
        this.contentStyle['border-bottom-left-radius'] = '0%';
        this.contentStyle['border-top-left-radius'] = '0%';
        this.contentStyle['border-bottom-right-radius'] = '0%';
        this.contentStyle['border-top-right-radius'] = '0%';
        break;
      case 'circle':
        this.contentStyle['border-bottom-left-radius'] = '50%';
        this.contentStyle['border-top-left-radius'] = '50%';
        this.contentStyle['border-bottom-right-radius'] = '50%';
        this.contentStyle['border-top-right-radius'] = '50%';
        break;
    }
  }
}
